export default String.raw`
{% assign product = include -%}

{% if customer.Carts[1] or customer.Cart.EditedOrderId -%}
	{% for oneOfCart in customer.Carts -%}
		{% if oneOfCart.Current -%}
			{% assign currentCartId = oneOfCart.Id -%}
			{% assign currentCartName = oneOfCart.Name -%}
		{% endif -%}
	{% endfor -%}
{% endif -%}

{% for unit in product.Units -%}
	{% if unit.Default == true or unit.Id == null -%}
		{% assign unitId = unit.Id -%}
	{% endif -%}
{% endfor -%}

{% assign directAddToCart = false -%}
{% if product.Attributes == null and product.AttributesEditable == null and product.AttributesPolyvalent == null and product.HasAttributes == false -%}
    {% assign directAddToCart = true -%}
{% else -%}
    {% assign productAttributesSize = product.Attributes | Size -%}
    {% if productAttributesSize == 1 -%}
        {% if product.Attributes[0].Name contains '360photo' -%}
            {% assign directAddToCart = true -%}
        {% endif -%}
        {% assign productAttributesValuesSize = product.Attributes[0].Values | Size -%}
        {% if productAttributesValuesSize == 1 -%}
            {% assign directAddToCart = true -%}
        {% endif -%}
    {% endif %}
{% endif -%}

<div class="cart-recommendations-item swiper-slide">
    <div class="cart-recommendations-item__wrapper">
        <div class="cart-recommendations-item__image-wrapper">
            {% if product.Image -%}
                {{product | Img: 'large' }}
            {% else %}
                <svg>
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use>
                </svg>
            {% endif -%}
            <div class="cart-recommendations-item__flags">
                {% if isDiscountItem -%}
                    <div title="{{ product.Name }}" class="cart-recommendations-item__flag">
                        {{ product.Name }}
                    </div>
                    {% if product.Quantity > 0 -%}
                        <div title="{{ product.Quantity | Normalize }} {{ product.SaleUnit }}" class="cart-recommendations-item__flag quantity-flag">
                            {{ product.Quantity | Normalize }} {{ product.SaleUnit }}
                        </div>
                    {% endif -%}
                {% else -%}
                    {% for flag in product.Flags limit: 2 %}
                        <div title="{{ flag.Text }}" class="cart-recommendations-item__flag {{ flag.Type }}">
                            {% if flag.Type == "Reward" -%}
                                {{ translations.PointsProduct }}
                            {% else -%}
                                {{ flag.Text}}
                            {% endif -%}
                        </div>
                    {% endfor %}
                {% endif -%}
            </div>
        </div>
        <div class="cart-recommendations-item__section">
            {% if isDiscountItem == false -%}
                {% if settings.recommendedAIInCart == 'yes' -%}
                    <a href="{{ page.BaseHref }}{{ product.Url }}?ai-cart-recommendation=true" class="recommended-product-link-in-cart-js" aria-label="product-link">
                {% else -%}
                    <a href="{{ page.BaseHref }}{{ product.Url }}" class="recommended-product-link-in-cart-js" aria-label="product-link">
                {% endif -%}
            {% endif -%}
                    <h3 class="cart-recommendations-item__name">{{ product.NameNoHtml }}</h3>
            {% if isDiscountItem == false -%}
                </a>
            {% endif -%}
        </div>
        <div class="cart-recommendations-item__section">
            <div class="cart-recommendations-item__price-wrapper">
                <span class="cart-recommendations-item__price bold-price">
                    {% if isDiscountItem -%}
                        {% if product.DiscountType == 3 or product.DiscountType == 11 -%}
                            {% assign productValueToDisplay = product.Value %}
                        {% else -%}
                            {% assign productValueToDisplay = product.Value | Minus: product.DiscountValue %}
                        {% endif -%}
                        {% if productValueToDisplay > 0 -%}
                            {{ productValueToDisplay | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}
                        {% else -%}
                            {{ translations.Free }}!
                        {% endif -%}
                    {% else -%}
                        {{ product.Price | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}
                    {% endif -%}
                </span>

                {% if product.PreviousPrice > product.Price and product.PreviousPrice != null -%}
                    <span class="cart-recommendations-item__price old-price" {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' %} title="{{translations.SuggestedRetailPrice}}" {% endif -%}>
                        {{ product.PreviousPrice | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} 
                        {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
                            <svg>
                                <use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#info-circle-{{settings.iconStyle}}"></use>
                            </svg>
                        {% endif -%}
                    </span>
                {% elseif product.RegularPrice > product.Price and product.RegularPrice != null and config.ENTERPRISE and settings.lowestProductPrice == 'no'-%}
                    <span class="cart-recommendations-item__price old-price">
                        {{ product.RegularPrice | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}
                    </span>
                {% endif -%}

                {% if isDiscountItem -%}
                    {% assign productPrice = productValueToDisplay %}
                    {% assign isSubtotalPrices = product.IsNetPrice -%}
                {% else -%}
                    {% assign productPrice = product.Price %}
                    {% assign isSubtotalPrices = customer.Cart.SubtotalPrices -%}
                {% endif -%}
                {% if productPrice > 0 -%}
                    <span class="cart-recommendations-item__price">
                        {% if isSubtotalPrices -%}
                            {{ translations.Netto | Downcase }}
                        {% else -%}
                            {{ translations.Brutto | Downcase }}
                        {% endif -%}
                    </span>
                {% endif -%}
            </div>
            {% if product.PreviousPrice > product.Price and product.PreviousPrice != null and settings.lowestProductPrice == 'yes' -%}
                <div class="cart-recommendations-item__omnibus">
                    <span>{{ product.MinPrice | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
                    <span>
                        {% if customer.Cart.SubtotalPrices -%}
                            {{ translations.Netto | Downcase }}
                        {% else -%}
                            {{ translations.Brutto | Downcase }}
                        {% endif -%}
                    </span>
                    <span> - {{translations.Price_Omnibus}}</span>
                </div>
            {% else -%}
                <div class="cart-recommendations-item__omnibus-placeholder"></div>
            {% endif -%}
        </div>
        <div class="cart-recommendations-item__section btn-section {% if directAddToCart -%} form-js add-to-cart-js {% endif -%}">
            {% if isDiscountItem == false and product.Price == null or product.AskForPrice -%}
                <a class="primary-action-button cart-recommendations-item__primary-btn" href="{{ page.BaseHref }}{{product.Url}}?open=askForPrice">
                    {{ translations.AskForPrice }}
                </a>
            {% else -%}
                {% if directAddToCart -%}
                    <input type="hidden" name="__action" value="Cart/Add" >
                    <input type="hidden" name="productId" value="{% if isDiscountItem -%}{{ product.ProductId }}{% else -%}{{ product.Id }}{% endif -%}" >
                    <input name="unitId" type="hidden" value="{{ unitId }}">
                    <input name="quantity" type="hidden" value="{% if isDiscountItem -%}{{ product.Quantity | ToInt }}{% else -%}1{% endif -%}">
                    {% if config.Products.AIEnabled == true and settings.recommendedAIInCart == 'yes' and page.PageId == config.DefinedPages.Order.Id -%}
                        <input  name="source" type="hidden" value="2"/>
                    {% endif -%}
                {% endif -%}
                <button class="primary-action-button cart-recommendations-item__primary-btn {% if directAddToCart -%} parent-container-reload-js add-to-cart-button-js add-to-cart-update-client-area-js parent-container-reload-js {% else -%} open-add-to-cart-popup-js choose-variant-js {% endif -%}" {% if directAddToCart != true -%} data-url="{{ page.BaseHref }}{{ product.Url }}" data-cart="true" {% endif -%} {% if isDiscountItem -%} data-discount="true" {% endif -%}>
                    <span>
                        {% capture end -%} <span class="cart-name-js"> {{ currentCartName }}</span>{% endcapture -%}
                        {% assign cartsAmount = customer.Carts | Size -%}
                        {% if customer.Cart.EditedOrderId or cartsAmount > 1 -%}
                            {% if customer.Cart.EditedOrderId -%}
                                {{ translations.AddToOrderSplitted | Format: end }}
                            {% else -%}
                                {{ translations.AddToCartSplittedWithName | Format: '', end }}                                
                            {% endif -%}
                        {% else -%}
                            {{ translations.AddToCartSplitted | Format: '' }}
                        {% endif -%}
                    </span>
                    <svg>
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{settings.cartIconStyle}}-{{settings.iconStyle}}"></use>
                    </svg>
                </button>
            {% endif -%}
        </div>
    </div>
</div>
`